export default __webpack_public_path__ + "static/media/pi-3.f4b57fbd.jpg";